import { initCacheInvalidatorRegister } from '../cacheRegisterConstructor';

export enum OrganizationDocumentsCacheEvents {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  MOVE = 'MOVE',
}

type CacheParams = {
  organizationId: string;
  folderId?: string;
};

const cacheRegister = initCacheInvalidatorRegister<
  typeof OrganizationDocumentsCacheEvents,
  CacheParams
>(OrganizationDocumentsCacheEvents);

export const invalidateOrganizationDocumentsCache = cacheRegister.invalidate;
export const organizationDocumentsCacheRegister = cacheRegister.register;
